import { Button } from "primereact/button";
import React from "react";
import { PhotoCardProps } from "./types";

export const PhotoCard = ({
  photo,
  index,
  isMain,
  isFeatured,
  onSetMain,
  onDelete,
  isLoading,
}: PhotoCardProps) => {
  if (isMain) {
    return (
      <div className="mb-3">
        <div className="surface-card p-3 border-round border-2 border-primary">
          <div className="flex align-items-center gap-2 mb-3">
            <div
              className="flex align-items-center justify-content-center bg-primary border-circle"
              style={{ width: "1.5rem", height: "1.5rem" }}
            >
              <i className="pi pi-camera text-white text-xs" />
            </div>
            <div>
              <span className="font-semibold text-900">
                Main Location Photo
              </span>
              <span className="text-xs text-600 block">
                Currently displayed as primary image
              </span>
            </div>
          </div>
          <div className="relative border-round overflow-hidden">
            <img
              src={photo.url}
              alt="Main location view"
              className="w-full"
              style={{ height: "250px", objectFit: "cover" }}
            />
            <div className="absolute top-0 right-0 p-2">
              <Button
                icon="pi pi-trash"
                className="p-button-rounded p-button-danger p-button-sm"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onDelete();
                }}
                disabled={isLoading}
                tooltip="Delete photo"
                tooltipOptions={{ position: "left" }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-12 md:col-6 lg:col-4">
      <div className="group relative">
        <div
          className={`surface-card border-round-lg overflow-hidden shadow-1 hover:shadow-3 transition-all transition-duration-300 ${isFeatured ? "ring-2 ring-success" : ""}`}
        >
          <div className="relative bg-surface-100">
            <img
              src={photo.url}
              alt={`Gallery view ${index + 1}`}
              className="w-full"
              style={{ height: "200px", objectFit: "cover", display: "block" }}
            />
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, transparent 30%, transparent 100%)",
                pointerEvents: "none",
              }}
            />
            {isFeatured && (
              <div
                className="absolute bottom-0 left-0 w-full px-3 py-2"
                style={{ backgroundColor: "rgba(34, 197, 94, 0.9)" }}
              >
                <div className="flex align-items-center gap-2">
                  <i className="pi pi-star text-white text-sm" />
                  <span className="text-white text-sm font-semibold">
                    Featured Photo
                  </span>
                </div>
              </div>
            )}
            <div className="absolute top-0 right-0 p-2">
              <div className="flex gap-2">
                <Button
                  icon="pi pi-camera"
                  className="p-button-rounded p-button-sm bg-white text-primary hover:bg-primary hover:text-white shadow-2"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onSetMain();
                  }}
                  disabled={isLoading}
                  tooltip="Set as main photo"
                  tooltipOptions={{ position: "bottom" }}
                />
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-sm bg-white text-red-500 hover:bg-red-500 hover:text-white shadow-2"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDelete();
                  }}
                  disabled={isLoading}
                  tooltip="Delete photo"
                  tooltipOptions={{ position: "bottom" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
